export const DEFAULT_YEAR_START = 1999;
export const YEAR_OPTION_LIMIT = 25;
export const TIME_OPTION_PREFIX = 'time-option-';
export const DEFAULT_APPT_START_TIME = 9;
export const DEFAULT_APPT_END_TIME = 9;
